<template>
  <div>
    <div style='width:300px; margin: 0 auto'>
      <div style='text-align: center; margin-bottom: 10px; font-size:2.0rem; font-weight:bold;'> {{qrOptions.title}}</div>
      <div class='qr-code-wrap' style='margin: 0 auto'>
        <QRCanvas class='qr-code'  :options="getQrOptions" @updated="onQrUpdated"></QRCanvas>
      </div>
      <div class='dx-field' style='text-align:center;margin:20px auto 0 auto;width:200px;'>
        <div class="dx-field-label">
          <DxNumberBox
            :value.sync="printQrCount"
            :min="1"
            :max="10"
            width='80'
            :show-spin-buttons="true"
            :show-clear-button='false'
            placeholder='출력매수'
          />
        </div>
          <div class="dx-field-value" style='margin-top:5px;'>
          <DxButton
            text='프린트'
            type='danger'
            width='110'
            @click="onPrintQrcode($event)"
          />
        </div>
      </div>
    </div>
    <div style="margin-top:10px;">
      <dx-data-grid
        :data-source='zebraInfo'
        :show-borders = 'true' :showRowLines = 'false' :showColumnLines='true'
        :hover-state-enabled = "true" :allowColumnResizing = 'true'
        column-resizing-mode = 'widget' :allow-column-reordering = "true"
        :height='200' :row-alternation-enabled="true"
        :focused-row-enabled="true"
        @focused-row-changed="onSelectionChangedZebra"
        :auto-navigate-to-focused-row="false"
        :focused-row-key.sync='focusedRowKey'
        key-expr="seqId"
      >
        <DxColumn
          :allowEditing='true'
          caption="지역"
          data-field="지역"
          :visible='true'
          sort-order="asc"
        >
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          caption="프린터명"
          data-field="프린터명"
          :visible='true'
          sort-order="asc"
        >
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          caption="주소"
          data-field="프린터주소"
          :visible='true'
        >
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          caption="포트"
          data-field="포워팅포트"
          :visible='true'
        >
        </DxColumn>
        <DxSummary>
          <DxTotalItem
            value-format='#,##0'
            column="지역"
            display-format="{0} (건)"
          />
        </DxSummary>
        <dx-paging :enabled="false"/>
        <dx-scrolling mode="virtual" showScrollbar='always' :useNative='false'/>
        <dx-sorting mode="multiple"/>
      </dx-data-grid>
    </div>
  </div>
</template>

<script>
import ConstDef from '../../share/ConstDef'
// import AppLib from '../../share/AppLib'
import DxDataGrid, { DxScrolling, DxTotalItem,
  DxSummary, DxColumn, DxPaging, DxSorting } from 'devextreme-vue/data-grid'
import { DxButton } from 'devextreme-vue'
import DxNumberBox from 'devextreme-vue/number-box'
import HttpService from '../../share/service/HttpService'
const { QRCanvas } = require('qrcanvas-vue')

export default {
  name: 'login',
  props: {
    qrOptions: Object
  },
  data: function () {
    return {
      userInfo: null,
      popupQrcode: false,
      printQrCount: 1,
      // zebra info
      zebraInfo: null,
      selectedZebraInfo: null,
      focusedRowKey: null
    }
  },
  components: {
    DxDataGrid,
    DxColumn,
    DxPaging,
    DxSorting,
    DxSummary,
    DxTotalItem,
    DxScrolling,
    QRCanvas,
    DxButton,
    DxNumberBox
  },
  computed: {
    getQrOptions () {
      return this.qrOptions
    }
  },
  created () {
    this.userInfo = this.$store.getters.getUserInfo
    if (this.userInfo === null) {
      this.$router.push('/')
      return
    }
    this.refreshZebraInfo()
  },
  mounted () {
  },
  updated () {
  },
  beforeDestroy: function () {

  },
  methods: {
    refreshZebraInfo () {
      this.$_sp.runNoEncodeFindSqlProc('프린터설정', null)
        .then((data) => {
          this.zebraInfo = this.$_sp.MakeModel(data)
          if (this.zebraInfo.length === 1) {
            this.focusedRowKey = this.zebraInfo[0].seqId
          }
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    // qr code popup *********
    onPrintQrcode (e) {
      if (this.selectedZebraInfo === null) {
        this.$snotify.info('출혁 할 프린터 정보를 선택하여 주세요.')
        return
      }
      this.$snotify.confirm(`${this.selectedZebraInfo.프린터명}로 (${this.printQrCount}매) 프린팅 하시겠습니까?`, '', {
        timeout: 10000,
        showProgressBar: true,
        closeOnClick: false,
        pauseOnHover: true,
        buttons: [
          { text: '프린트',
            action: (toast) => {
              this.$snotify.remove(toast.id)
              this.printQrcode()
            }
          },
          { text: '취소',
            action: (toast) => { this.$snotify.remove(toast.id) }
          }
        ]
      })
    },
    onQrUpdated (e) {
      console.log(e)
      console.log(e.width)
      this.$Q('.qr-code-wrap').css('width', e.width + 'px')
    },
    async printQrcode () {
      this.isLoading = true
      const temp = {
        지역: this.selectedZebraInfo.지역,
        프린터명: this.selectedZebraInfo.프린터명,
        프린터주소: this.selectedZebraInfo.프린터주소,
        포워딩포트: this.selectedZebraInfo.포워딩포트,
        qrCode: this.qrOptions.data,
        문자: `${this.qrOptions.text}`,
        문자2: `${this.qrOptions.text2}`,
        항목: `${this.qrOptions.name}`,
        항목2: `${this.qrOptions.name2}`,
        장수: this.printQrCount,
        완료: 0,
        사용유무: 1,
        createid: this.userInfo.userName,
        updateid: this.userInfo.userName
      }
      await this.$_sp.runInsertSqlProc('프린팅대기', null, [temp])
        .then((data) => {
          this.$snotify.info('QR Code 프린팅 요청하였습니다.')
          HttpService.reqPost(JSON.stringify({ printName: this.selectedZebraInfo.프린터명 }), '/qrCodePrinting')
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
      this.isLoading = false
    },
    // zebran grid
    onSelectionChangedZebra (e) {
      if (e != null && e.row === undefined) {
        return
      }
      if (e !== null) {
        this.selectedZebraInfo = e.row.data
      }
    }

  }
}
</script>

<style lang="scss">
.ff{
  text-align: center;
}
</style>
